export function titleize(str) {
  return str.replace(/[-_]/g, ' ').replace(/(?:^|\s)\S/g, (s) => s.toUpperCase());
};
export const presentAsLine = (...items) => _.join(_.compact(items), ' • ');
